import React, { Fragment } from 'react'
import useAutocomplete from '../../../hooks/useAutocomplete'
import { ApiConfig } from '../../../config/api'
import { User } from '../../../interfaces/User/User'
import { AutoCompleterRequired } from '../../AutoCompleter/AutoCompleterRequired'

interface PositionAutocompleteProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  userAliasValue: string
  UserAliasList?: string
  isError?: React.Dispatch<React.SetStateAction<boolean>>
}

export const UserAutocomplete: React.FC<PositionAutocompleteProps> = ({
  handleChange,
  userAliasValue,
  UserAliasList = 'userAlias',
  isError
}) => {
  const { data: posiciones, loader: loaderUsuarios } = useAutocomplete<User>(
    userAliasValue,
    `${ApiConfig.UserApi}/GetByUserAlias?userAlias=${userAliasValue}`,
    3
  )

  return (
    <Fragment>
      <AutoCompleterRequired
        item={posiciones.map((item: any) => {
          return {
            value: item.userAlias
          }
        })}
        nameList={UserAliasList}
        labelList={'Usuario'}
        handleChange={handleChange}
        isLoader={loaderUsuarios}
        value={userAliasValue}
        required={true}
        isError={isError}
      />
    </Fragment>
  )
}
